import Vilang from './entries/vi-VN';
import Enlang from './entries/en-US';

const appLocales = {
  'en-US': Enlang,
  'vi-VN': Vilang,
};

export default appLocales;
